/**
 * 图生文工具任务 API 服务
 * 封装提交任务、查询详情、列表、导出等接口
 */

import { AUTH_TOKEN_KEY, apiService } from './api'
import type {
  ImageToTextTaskDetailResponse,
  ImageToTextTaskListResponse,
  SubmitImageToTextTaskRequest,
  SubmitImageToTextTaskResponse,
} from '../types/imageToTextTask'

interface ApiResponse<T> {
  code: number
  message: string
  data: T
}

/**
 * 提交图生文批量任务
 */
export async function submitImageToTextTask(
  req: SubmitImageToTextTaskRequest
): Promise<SubmitImageToTextTaskResponse> {
  const res = await apiService.post<ApiResponse<SubmitImageToTextTaskResponse>>(
    '/api/user/image-to-text-tasks',
    req
  )
  return res.data
}

/**
 * 查询图生文任务详情（含子任务列表）
 */
export async function getImageToTextTask(id: string): Promise<ImageToTextTaskDetailResponse> {
  const res = await apiService.get<ApiResponse<ImageToTextTaskDetailResponse>>(
    `/api/user/image-to-text-tasks/${id}`
  )
  return res.data
}

/**
 * 查询图生文任务列表（分页）
 */
export async function listImageToTextTasks(
  params: { page?: number; pageSize?: number } = {}
): Promise<ImageToTextTaskListResponse> {
  const { page = 1, pageSize = 20 } = params
  const res = await apiService.get<ApiResponse<ImageToTextTaskListResponse>>(
    '/api/user/image-to-text-tasks',
    { page: String(page), page_size: String(pageSize) }
  )
  return res.data
}

/**
 * 导出任务结果 CSV（触发浏览器下载）
 */
export function exportImageToTextTaskCSV(id: string): void {
  const token = localStorage.getItem(AUTH_TOKEN_KEY) ?? ''
  const baseUrl: string = import.meta.env.VITE_API_BASE_URL ?? ''
  const fullPath = `${baseUrl}/api/user/image-to-text-tasks/${id}/export`
  const url = fullPath.startsWith('http')
    ? fullPath
    : `${window.location.origin}${fullPath}`

  // 通过 fetch 下载，附带认证 token
  fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
    .then(async (response) => {
      if (!response.ok) throw new Error('导出失败')
      const blob = await response.blob()
      const disposition = response.headers.get('Content-Disposition') ?? ''
      const match = disposition.match(/filename="([^"]+)"/)
      const filename = match?.[1] ?? `export_${id}.csv`
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl)
    })
    .catch((err: unknown) => {
      console.error('导出失败:', err)
    })
}
